import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import currencyFormat from 'src/utils/formatCOP';
import onMouseResultsMap from 'src/utils/onMouseResultsMap';

import { useStyles, StyledTableCell } from '../reportsBoard/styles';
import LoadingRows from './LoadingRows';

const TableAAPP = ({
  array = [], selectedDate, title, param, colParam = false, AA,
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="spanning table">
          <TableHead>
            <TableRow>
              <StyledTableCell colSpan={!colParam ? 4 : 6} align="center">
                Unidades Enero - Diciembre
              </StyledTableCell>
              <StyledTableCell colSpan={!colParam ? 3 : 5} align="center">
                Pesos Enero - Diciembre
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell align="center">{title}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              {colParam && <StyledTableCell align="right">{selectedDate.getFullYear() - 2}</StyledTableCell>}
              <StyledTableCell align="right">AA</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear()}</StyledTableCell>
              <StyledTableCell align="right">{selectedDate.getFullYear() - 1}</StyledTableCell>
              {colParam && <StyledTableCell align="right">{selectedDate.getFullYear() - 2}</StyledTableCell>}
              <StyledTableCell align="right">{AA ? 'AA' : 'AAA'}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {array.length > 0 ? (
              array.map((row) => (
                row[param] &&
                <TableRow key={Math.random()}>
                  <TableCell align="left">{row[param].toUpperCase()}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.PERIODO1 || 0, 10))}</TableCell>
                  <TableCell align="right">{currencyFormat(parseInt(row.PERIODO2 || 0, 10))}</TableCell>
                  {colParam && <TableCell align="right">{currencyFormat(parseInt(row.PERIODO3 || 0, 10))}</TableCell>}
                  <TableCell align="right">
                    {(+row.AA * (!AA ? 100 : 1)).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {((+row.P1 || +row.MS1 || 0) * 100).toFixed(2)}
                    %
                  </TableCell>
                  <TableCell align="right">
                    {((+row.P2 || +row.MS2 || 0) * 100).toFixed(2)}
                    %
                  </TableCell>
                  {colParam && (
                  <TableCell align="right">
                    {(+row.P3 || 0 * 100).toFixed(2)}
                    %
                  </TableCell>
                  )}
                  <TableCell align="right">
                    {((+row.DELTA_PESO || +row.DIFMS || 0) * (AA ? 100 : 1)).toFixed(2)}
                    %
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                  <TableCell><LoadingRows /></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell>TOTAL</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO1')}</TableCell>
              <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO2')}</TableCell>
              {colParam && <TableCell align="right">{onMouseResultsMap.totals(array, 'PERIODO2')}</TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableAAPP;
